import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Typography,
} from '@mui/material';

/**
 * Port 1:1 de `src/pages/InspecionarProcesso/Acompanhamento/DialogSimularQuitacao.jsx`
 * (tela real) para MUI v5. Somente leitura — sem campo de data (a implementação
 * real não pede data ao usuário; ver AW2-1032 Etapa 2 no plano da feature).
 */
export default function DialogSimularQuitacao({ open, texto, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Simular Quitação</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          multiline
          rows={15}
          disabled
          value={texto}
          sx={{
            mb: 2,
            '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: '#000000' },
          }}
        />
        <Typography component="pre" variant="body2">
          * Para efetuar a quitação, utilize as funcionalidades de Acordo para realizar uma nova negociação.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>OK</Button>
      </DialogActions>
    </Dialog>
  );
}

DialogSimularQuitacao.propTypes = {
  open: PropTypes.bool,
  texto: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

DialogSimularQuitacao.defaultProps = {
  open: false,
  texto: '',
};
